import { render } from "./ReferencesSliderSection.vue?vue&type=template&id=733c1500"
import script from "./ReferencesSliderSection.vue?vue&type=script&lang=js"
export * from "./ReferencesSliderSection.vue?vue&type=script&lang=js"

import "./ReferencesSliderSection.vue?vue&type=style&index=0&id=733c1500&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__